import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const developers = [
  { name: 'Emaar Properties', founded: 1997, completedProjects: 47, onTimeDelivery: 96, avgDelay: 1.2, qualityRating: 4.8, priceAppreciation: 22, activeProjects: 12, totalUnits: 45000 },
  { name: 'Sobha Realty', founded: 1976, completedProjects: 18, onTimeDelivery: 99, avgDelay: 0.3, qualityRating: 4.9, priceAppreciation: 18, activeProjects: 6, totalUnits: 8500 },
  { name: 'Meraas', founded: 2007, completedProjects: 22, onTimeDelivery: 97, avgDelay: 0.8, qualityRating: 4.7, priceAppreciation: 20, activeProjects: 8, totalUnits: 12000 },
  { name: 'Nakheel', founded: 2000, completedProjects: 29, onTimeDelivery: 94, avgDelay: 2.1, qualityRating: 4.5, priceAppreciation: 25, activeProjects: 9, totalUnits: 35000 },
  { name: 'DAMAC Properties', founded: 2002, completedProjects: 38, onTimeDelivery: 88, avgDelay: 4.5, qualityRating: 4.1, priceAppreciation: 15, activeProjects: 15, totalUnits: 28000 },
  { name: 'Azizi Developments', founded: 2007, completedProjects: 31, onTimeDelivery: 82, avgDelay: 6.2, qualityRating: 3.8, priceAppreciation: 12, activeProjects: 18, totalUnits: 18000 }
];

const DeveloperPerformance = () => {
  const [sortBy, setSortBy] = useState('onTimeDelivery');
  const [selected, setSelected] = useState(null);

  const sorted = [...developers]?.sort((a, b) => b?.[sortBy] - a?.[sortBy]);
  const getColor = (v, max) => v >= max * 0.9 ? '#22c55e' : v >= max * 0.7 ? '#f59e0b' : '#ef4444';

  return (
    <div className="rounded-2xl p-6" style={{ background: 'rgba(10,22,40,0.9)', border: '1px solid rgba(0,212,255,0.2)' }}>
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.3)' }}>
            <Icon name="Award" size={20} color="#00D4FF" />
          </div>
          <div>
            <h3 className="text-lg font-bold" style={{ color: '#E8F4FF' }}>Developer Performance Tracker</h3>
            <p className="text-xs" style={{ color: '#6B9EC4' }}>Historical completion records and delivery timelines</p>
          </div>
        </div>
        <select value={sortBy} onChange={e => setSortBy(e?.target?.value)}
          className="px-3 py-2 rounded-lg text-xs outline-none"
          style={{ background: 'rgba(10,22,40,0.9)', border: '1px solid rgba(0,212,255,0.2)', color: '#E8F4FF' }}>
          <option value="onTimeDelivery">Sort: On-Time Delivery</option>
          <option value="qualityRating">Sort: Quality Rating</option>
          <option value="priceAppreciation">Sort: Price Appreciation</option>
          <option value="completedProjects">Sort: Projects Completed</option>
        </select>
      </div>
      <div className="space-y-3">
        {sorted?.map((dev, i) => (
          <div key={i}>
            <button onClick={() => setSelected(selected?.name === dev?.name ? null : dev)}
              className="w-full text-left p-4 rounded-xl transition-all"
              style={{ background: selected?.name === dev?.name ? 'rgba(0,212,255,0.1)' : 'rgba(0,212,255,0.04)', border: `1px solid ${selected?.name === dev?.name ? 'rgba(0,212,255,0.4)' : 'rgba(0,212,255,0.12)'}` }}>
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <span className="text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center" style={{ background: i < 3 ? 'rgba(0,212,255,0.2)' : 'rgba(255,255,255,0.05)', color: i < 3 ? '#00D4FF' : '#6B9EC4' }}>#{i + 1}</span>
                  <span className="font-semibold text-sm" style={{ color: '#E8F4FF' }}>{dev?.name}</span>
                </div>
                <span className="text-xs" style={{ color: '#6B9EC4' }}>Est. {dev?.founded}</span>
              </div>
              <div className="grid grid-cols-3 gap-2">
                <div>
                  <div className="text-xs" style={{ color: '#6B9EC4' }}>On-Time</div>
                  <div className="text-sm font-bold" style={{ color: getColor(dev?.onTimeDelivery, 100) }}>{dev?.onTimeDelivery}%</div>
                </div>
                <div>
                  <div className="text-xs" style={{ color: '#6B9EC4' }}>Quality</div>
                  <div className="text-sm font-bold" style={{ color: getColor(dev?.qualityRating, 5) }}>{dev?.qualityRating}/5</div>
                </div>
                <div>
                  <div className="text-xs" style={{ color: '#6B9EC4' }}>Appreciation</div>
                  <div className="text-sm font-bold" style={{ color: '#22c55e' }}>+{dev?.priceAppreciation}%</div>
                </div>
              </div>
            </button>
            {selected?.name === dev?.name && (
              <div className="mt-2 p-4 rounded-xl" style={{ background: 'rgba(0,212,255,0.05)', border: '1px solid rgba(0,212,255,0.15)' }}>
                <div className="grid grid-cols-2 gap-3">
                  {[
                    { label: 'Completed Projects', value: dev?.completedProjects },
                    { label: 'Active Projects', value: dev?.activeProjects },
                    { label: 'Total Units Delivered', value: dev?.totalUnits?.toLocaleString() },
                    { label: 'Avg Delay (months)', value: dev?.avgDelay }
                  ]?.map((item, j) => (
                    <div key={j} className="p-2 rounded-lg" style={{ background: 'rgba(10,22,40,0.6)' }}>
                      <div className="text-xs" style={{ color: '#6B9EC4' }}>{item?.label}</div>
                      <div className="text-sm font-bold" style={{ color: '#E8F4FF' }}>{item?.value}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DeveloperPerformance;
